/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';


const SpotifyPlayer = ({
  handlerSetComponents, components, id,
}) => {
  const initialState = {
    type: 'SpotifyPlayer',
    listId: '',
    albumId: '',
    trackId: '',
    height: 400,
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  const inputHandler = (e) => {
    const { value, name, lang } = e.target;
    const { component } = components[index];
    const comp = {
      ...component,
      [name]: value,
    };
    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    setIndex(componentIndex);
    if (component) {
      setState(component);
    } else {
      const componentObj = {
        id,
        component: state,
      };
      handlerSetComponents(componentObj, componentIndex);
    }
  }, [components]);

  return (
    <div className="w-full bg-greyFilter pl-8 flex flex-row pb-1 rounded-lg">
      <div className={`flex w-full ${(state.listId || state.albumId) ? 'flex-col self-center' : 'flex-row'}`}>
        <label className={`font-americaMonoRegular text-xs mt-1 uppercase text-black pl-6 pr-4 ${(state.listId || state.albumId || state.trackId) ? 'w-full' : 'w-1/2'}`} htmlFor="spotifylist">
          <span>Spotify playlist id</span>
          <input className={`font-americaMonoRegular w-full bg-white outline-none rounded-full p-2 ${(state.listId || state.albumId || state.trackId) ? 'mt-0' : 'mt-1' }`} onChange={inputHandler} name="listId" type="text" value={state.listId} />
        </label>
        <label className={`font-americaMonoRegular text-xs mt-1 uppercase text-black block ${(state.listId || state.albumId || state.trackId) ? 'w-full pl-6 pr-4 pt-2' : 'w-1/2 pr-3'}`} htmlFor="spotifyalbum">
          <span>Spotify album id</span>
          <input className="font-americaMonoRegular w-full bg-white outline-none rounded-full mt-1 p-2" onChange={inputHandler} name="albumId" type="text" value={state.albumId} />
        </label>
        <label className={`font-americaMonoRegular text-xs mt-1 uppercase text-black block ${(state.listId || state.albumId || state.trackId) ? 'w-full pl-6 pr-4 pt-2' : 'w-1/2 pr-3'}`} htmlFor="spotifytrack">
          <span>Spotify track id</span>
          <input className="font-americaMonoRegular w-full bg-white outline-none rounded-full mt-1 p-2" onChange={inputHandler} name="trackId" type="text" value={state.trackId} />
        </label>
        <label className={`font-americaMonoRegular text-xs mt-1 uppercase text-black block ${(state.listId || state.albumId || state.trackId) ? 'w-full pl-6 pr-4 pt-2' : 'w-1/2 pr-3'}`} htmlFor="spotifytrack">
          <span>Height</span>
          <input className="font-americaMonoRegular w-full bg-white outline-none rounded-full mt-1 p-2" onChange={inputHandler} name="height" type="text" value={state.height || 400} />
        </label>
      </div>
      {state.listId
        ? <div className="rounded w-full xxxl:w-1/3"><iframe className="max-w-full pr-3 pt-1" title="spotify" src={`https://open.spotify.com/embed/playlist/${state.listId}`} width="380" height="300" frameBorder="0" allow="encrypted-media" /></div>
        : null}
      {state.albumId
        ? <div className="rounded w-full xxxl:w-1/3"><iframe className="max-w-full pr-3 pt-1" title="spotify" src={`https://open.spotify.com/embed/album/${state.albumId}`} width="380" height="300" frameBorder="0" allow="encrypted-media" /></div>
        : null}
      {state.trackId
        ? <div className="rounded w-full xxxl:w-1/3"><iframe className="max-w-full pr-3 pt-1" title="spotify" src={`https://open.spotify.com/embed/album/${state.trackId}`} width="380" height="300" frameBorder="0" allow="encrypted-media" /></div>
        : null}
    </div>
  );
};

SpotifyPlayer.propTypes = {
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
};

export default SpotifyPlayer;
